import { AspectRatio, Box, Card, Flex, Heading, Text } from "@radix-ui/themes";
import { createFileRoute } from "@tanstack/react-router";
import { Authenticated, Unauthenticated } from "convex/react";
import z from "zod";

import { AuthenticatedHome, UnauthenticatedHome } from "./-components";

import {
  REDIRECT_TO_SEARCH_PARAM_NAME,
  REDIRECT_TO_SEARCH_PARAM_ZOD_VALIDATOR,
  REQUIRE_AUTHENTICATION_SEARCH_PARAM_NAME,
  REQUIRE_AUTHENTICATION_SEARCH_PARAM_ZOD_VALIDATOR,
} from "@/constants/search";

export const Route = createFileRoute("/")({
  validateSearch: z.object({
    [REQUIRE_AUTHENTICATION_SEARCH_PARAM_NAME]:
      REQUIRE_AUTHENTICATION_SEARCH_PARAM_ZOD_VALIDATOR,
    [REDIRECT_TO_SEARCH_PARAM_NAME]: REDIRECT_TO_SEARCH_PARAM_ZOD_VALIDATOR,
  }),
  component: () => {
    return (
      <>
        <Card size={"4"}>
          <Flex direction="column" gap="2" align="center">
            <Box>
              <Heading size="8" align="center">
                Try New Hairstyles!
              </Heading>
              <Text size="4" color="gray" align="center">
                Upload your photo and see yourself with different hairstyles
              </Text>
            </Box>
            <AspectRatio ratio={16 / 9}>
              <Card className="w-full h-full p-0!">
                <img
                  src="/hero.png"
                  alt="Hairstyle demo"
                  className="rounded"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Card>
            </AspectRatio>
          </Flex>
        </Card>

        <Unauthenticated>
          <UnauthenticatedHome />
        </Unauthenticated>

        <Authenticated>
          <AuthenticatedHome />
        </Authenticated>
      </>
    );
  },
});
